<template>
	<div class="white-bg pad20">
		<el-page-header title="" @back="$router.go(-1)" content="我的发票" />
		<div class="hr"></div>
		<h3 class="mt20">发票信息</h3>
		<copylist text="公司名称"><span>北京三草月文化创意有限公司</span></copylist>
		<copylist text="公司税号"><span>91110108MA01XW0U0K</span></copylist>
		<copylist text="公司地址"><span>北京市海淀区中关村大街9号4幢3层329号</span></copylist>
		<copylist text="公司电话"><span>010-6269 2853</span></copylist>
		<copylist text="公司开户行"><span>招商银行股份有限公司北京海淀支行</span></copylist>
		<copylist text="开户行账号"><span>110944126610701</span></copylist>
		<copylist text="发票内容"><span>知识产权代理费</span></copylist>
		<copylist text="发票金额"><span> 200元</span></copylist>
		<copylist text="申请时间"><span>2022.2.22 10:50</span></copylist>
		<div class="hr"></div>
		<h3 class="mt20">作品著作权申请信息</h3>
		<div class="lists">
			<span>1张发票</span>
			<span class="ml20"><el-link :underline="false">查看</el-link></span>
		</div>
		<div class="lists">
			<span>含2个作品著作权申请登记</span>
			<span class="ml20"><el-link :underline="false">详情</el-link></span>
		</div>
		<div class="hr"></div>
		<h3 class="mt20">收件人信息</h3>
		<copylist text="收件人姓名"><span>刘先生</span></copylist>
		<copylist text="联系方式"><span>13590229044</span></copylist>
		<copylist text="收件地址"><span>北京东城北新桥街道东直门北小街小福智慧生活</span></copylist>
		<div class="hr"></div>
		<h3 class="mt20">物流信息</h3>
		<copylist text="快递公司"><span>顺丰快递</span></copylist>
		<copylist text="快递单号"><span>13590229044</span></copylist>
	</div>
</template>

<script>
	import copylist from '../../components/list/copyright.vue'
	export default {
		name: 'invoicedetails',
		components: {
			copylist
		},
		data() {
			return {


			}
		},
		created() {},
		updated() {},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>
.lists{
	display: flex;
	align-items: center;
	margin-top: 20px;
	line-height: 24px;
}
</style>
